import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { SelectVendorBilling } from "@features/selectVendorBilling/SelectVendorBilling";
import { PanVerificationBadge } from "@features/selectVendorBilling/ui/PanVerificationBadge";
import { IFinanceInfluencer } from "@shared/lib/types/briefCampains";
import { Button } from "@shared/ui/Button";
import { Flex, Modal, Space, Tag, Tooltip } from "antd";
import { useState } from "react";
import styles from "./styles.module.scss";

export function BillingDetails({
  financeInfluencer,
}: {
  financeInfluencer: IFinanceInfluencer;
}) {
  const billing = financeInfluencer.billingEntity;
  const [isVendorBillingModalProps, setVendorBillingModalProps] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  return (
    <div className={styles.card}>
      <Flex className={styles.cardHeader}>
        <div className={styles.cardTitle}>Billing Details</div>
        <Space>
          <Tag color="purple">{billing.type}</Tag>
          <Button
            danger
            type="link"
            icon={<EditOutlined />}
            onClick={() => setVendorBillingModalProps({ visible: true })}
          />
        </Space>
      </Flex>
      <div className={styles.billingBody}>
        <Flex>
          <div style={{ width: "220px", display: "block" }}>
            <div className={styles.billingTitle}>{billing.name}</div>
            <div className={styles.billingValue}>{billing.billingType}</div>
          </div>
          <div className={styles.billingContact}>
            {billing.phoneNumber
              ? `${billing.countryCode} ${billing.phoneNumber}`
              : billing.emailId}
            <Tooltip title={"Payout will be created here"}>
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </Flex>
        <Flex>
          {billing?.isGst && (
            <div style={{ width: "220px", display: "block" }}>
              <div className={styles.normalText}>{billing.gstNumber}</div>
              <div className={styles.normalValue}>
                GST {billing.gstPercentage}%
              </div>
            </div>
          )}
          {billing?.isPan && (
            <div
              style={{
                width: "220px",
                display: "grid",
                gap: 8,
              }}
            >
              <div className={styles.normalText}>{billing.panNumber}</div>
              <div className={styles.normalValue}>
                TDS {billing.tdsPercentage}%
              </div>
              <div style={{ width: "max-content" }}>
                <PanVerificationBadge billingEntity={billing} />
              </div>
            </div>
          )}
          <div style={{ display: "block" }}>
            <div className={styles.normalText}>{billing.addressLine1}</div>
            <div className={styles.normalValue}>{billing.addressLine2}</div>
            <div className={styles.normalValue}>
              {billing.city}, {billing.state}, {billing.pinCode},{" "}
              {billing.country}
            </div>
          </div>
        </Flex>
      </div>

      <Modal
        title="Edit Billing"
        destroyOnClose
        footer={null}
        width={1000}
        open={isVendorBillingModalProps.visible}
        onCancel={() => setVendorBillingModalProps({ visible: false })}
      >
        {isVendorBillingModalProps.visible && (
          <SelectVendorBilling
            campaignInfluencerId={
              financeInfluencer?.campaignInfluencer?._id || ""
            }
            influencerId={
              financeInfluencer?.campaignInfluencer?.influencerId || ""
            }
            name={
              financeInfluencer?.campaignInfluencer?.socialMedia?.username || ""
            }
            profilePicUrl={
              financeInfluencer?.campaignInfluencer?.socialMedia
                ?.profilePicUrl || ""
            }
            onClose={() => setVendorBillingModalProps({ visible: false })}
            isEdit={true}
          />
        )}
      </Modal>
    </div>
  );
}
